(()=>{
  const mount=()=>{
    if(document.getElementById('fleet-panda-cta-v3'))return;
    const heading=document.querySelector('#flotta .head h2');
    if(!heading||!heading.parentElement)return;

    const row=document.createElement('div');
    row.className='fleet-title-panda-row-v3';
    heading.parentElement.insertBefore(row,heading);
    row.appendChild(heading);

    const button=document.createElement('a');
    button.id='fleet-panda-cta-v3';
    button.className='fleet-panda-cta-v3';
    button.href='#fiat-panda';
    button.dataset.pandaEntryV2='true';
    button.dataset.pandaV2Bound='true';
    button.setAttribute('aria-label','Apri la prenotazione della Fiat Panda');
    button.innerHTML='<span>PRENOTA FIAT PANDA</span><small>AUTO UTILITARIA · 30 €/GIORNO · 7 GIORNI = 210 €</small>';
    row.appendChild(button);

    button.addEventListener('click',event=>{
      event.preventDefault();
      if(typeof window.MASSAGOMME_OPEN_RENT_PRIVATE==='function'){
        window.MASSAGOMME_OPEN_RENT_PRIVATE('pulsante_vicino_titolo_furgoni');
      }else{
        location.hash='fiat-panda';
      }
    });
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);
  else mount();
  window.addEventListener('pageshow',mount);
})();
